/**
 * Small input-masking helpers for the reimbursement form: phone numbers
 * formatted as the user types, and a "type digits, last two are cents"
 * currency mask (the common checkout-style money input).
 */

// Formats raw input into (XXX) XXX-XXXX as the user types, re-deriving the
// mask from the digits alone each time so backspacing/editing anywhere in
// the string still produces a sane result.
export const formatPhoneInput = (rawValue) => {
  const digits = rawValue.replace(/\D/g, '').slice(0, 10);
  const len = digits.length;
  if (len === 0) return '';
  if (len < 4) return `(${digits}`;
  if (len < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

// Extracts just the digits typed so far for the currency mask, capped so
// the resulting dollar amount stays reasonable (up to $99,999,999.99).
export const digitsFromCurrencyInput = (rawValue) => rawValue.replace(/\D/g, '').slice(0, 10);

// Converts the raw digit string (read as cents) into a dollars number.
export const dollarsFromDigits = (digits) => (digits ? parseInt(digits, 10) / 100 : 0);

// Formats the raw digit string as a "$1,234.56" display value.
export const formatCurrencyFromDigits = (digits) => {
  if (!digits) return '';
  return dollarsFromDigits(digits).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};
